import { Button, ButtonGroup } from '@material-ui/core'
import { isEmpty } from 'lodash'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { cancelSingleSession } from 'api'
import BaseEntity from 'app/components/BaseEntity'
import CancelModal from 'app/components/CancelEntity/CancelModal'
import { useStyles } from 'app/components/generic/Button'
import { exploreEnrolmentActions } from 'app/config'
import constants from 'app/constants'
import { eventAlert, eventEmitter } from 'app/helpers'
import {
  fetchExploreEnrolmentData,
  updateClassData
} from 'app/store/actions/classEntity'

import { columns } from './config'

import MasterModal from '../components/MasterModal'

const ExploreEnrolment = () => {
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const [isCancelModalOpen, setIsCancelModalOpen] = React.useState(false)
  const [action, setAction] = React.useState('')
  const [cancelId, setCancelId] = React.useState('')
  const [editIndex, setEditIndex] = React.useState(null)
  const exploreEnrolmentData = useSelector(
    (state) => state.classEntityReducer.exploreEnrolmentData
  )
  const dispatch = useDispatch()

  const openModal = React.useCallback((action, dataIndex) => {
    setIsModalOpen(true)
    setAction(action)
    setEditIndex(dataIndex)
  }, [])

  const closeModal = () => {
    setIsModalOpen(false)
  }

  const closeCancelModal = () => {
    setIsCancelModalOpen(false)
  }

  const onActionButtonClick = (e, action, dataIndex) => {
    if (action === 'cancel') {
      setIsCancelModalOpen(true)
    } else {
      openModal(action, dataIndex)
    }
  }

  const onSaveClick = async (newData, action) => {
    try {
      if (action === 'cancel_sessions') {
        const response = await cancelSingleSession({
          sessionId: cancelId,
          queries: {
            attendance: {
              reason: !isEmpty(newData?.notes?.trim())
                ? `${newData.reason}##${newData.notes}`
                : `${newData.reason}`
            },
            reason_for_using_alfred: newData.reason_for_using_alfred
          }
        })
        if (response.success) {
          eventEmitter.emit(constants.CLOSE_MODAL_FORM)
          eventAlert('Session canceled Successfully', constants.SUCCESS)
        }
        closeCancelModal()
      }

      const queries = JSON.parse(localStorage.getItem('filterQueries'))
      dispatch(
        fetchExploreEnrolmentData(
          { ...queries },
          false,
          false,
          constants.EXPLORE_ENROLMENT
        )
      )
    } catch (error) {
      console.log(error)
      eventEmitter.emit(constants.MODAL_FORM_SAVE_ERROR, error)
      eventAlert(error.message, constants.ERROR)
    }
  }
  const classes = useStyles()
  const modifiedColumns = React.useMemo(() => {
    return [
      ...columns,
      {
        name: '',
        label: 'actions',
        disabledInForm: true,
        options: {
          disableFilter: true,
          filter: false,
          sort: false,
          customBodyRenderLite: (dataIndex) => {
            const { status, is_termination_requested } =
              exploreEnrolmentData?.data[dataIndex] || {}

            return (
              status !== 'terminated' &&
              status !== 'expired' &&
              !is_termination_requested && (
                <ButtonGroup>
                  {Object.keys(exploreEnrolmentActions).map((action, index) => {
                    return (
                      <Button
                        key={'ExploreEnrolment' + index}
                        title={exploreEnrolmentActions[action]}
                        className={classes.button}
                        onClick={(e) => {
                          onActionButtonClick(e, action, dataIndex)
                        }}
                      >
                        {exploreEnrolmentActions[action]}
                      </Button>
                    )
                  })}
                </ButtonGroup>
              )
            )
          }
        }
      }
    ]
  }, [exploreEnrolmentData])

  return (
    <>
      <BaseEntity
        entity={constants.EXPLORE_ENROLMENT}
        label={constants.EXPLORE_ENROLMENT_LABEL}
        columns={modifiedColumns}
        data={exploreEnrolmentData}
        fetchData={fetchExploreEnrolmentData}
        updateEntityData={updateClassData}
        createDependency
        disableDelete
        readOnly
      />
      <MasterModal
        isModalOpen={isModalOpen}
        onSaveClick={onSaveClick}
        closeModal={closeModal}
        action={action}
        data={exploreEnrolmentData.data[editIndex] || {}}
        onActionButtonClick={onActionButtonClick}
        setCancelId={setCancelId}
        isProgramEnrolment={true}
      />
      <CancelModal
        isModalOpen={isCancelModalOpen}
        onSaveClick={onSaveClick}
        closeModal={closeCancelModal}
        action={action}
        cancelActionType="cancel_sessions"
        requireAlfredReason
      />
    </>
  )
}

export default ExploreEnrolment
